import React, { useEffect, useState, useRef } from "react";
import { Card, Table, Tooltip, Space, } from "antd";
import IconButton from "components/ui/Button/IconButton";
import { useNavigate } from 'react-router-dom';
import { ImagePaths } from "utils/ImagePath";
import ConfigurationFilter from "../ConfigurationFilter";
import CommonTblHeader from "components/common/CommonTblHeader";
import ToastMsg from "components/common/ToastMsg";
import useApiData from "components/common/useGetApiData";
import { getEmployeeWeekOffPagination } from "hooks/api/configurationApi/employeeWeekOffApi";
import { EMPLOYEE_WEEK_OFF } from 'constants';
import {checkUserPermissionFunc, deleteDraftItemsById} from "components/common/CommonFuntion";
import { CommonDeletePopup } from 'components/common/CommonComponent';
import useApiMethods from "hooks/apiConfig/method/apiMethods";
import { NEW_EMPLOYEE_WEEK_OFF } from "constant";

const initialData = {
  weekOff_code: "",
  weekOff_name: "",
  weekOff_is_active: "",
}
function EmployeeWeekOff() {
  let query = "";
  let queryRef = useRef("");
  const pageSize = 10;
  const authtoken = sessionStorage.getItem("token");

  const [editVisible, setEditVisible] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [dataUpdated, setDataUpdated] = useState(false);
  const [sorting, setSorting] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [dataToBeUpdated, setDataToBeUpdated] = useState({});
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterDatas, setFilterDatas] = useState({ initialData });
  const [reorderedColumns, setReorderedColumns] = useState([]);
  const [isDraft, setIsDraft] = useState(false);
  const [deleteItem, setDeleteClicked] = useState({ id: undefined, isDeleteClicked: false });
  const tableContainerHeight = isDraft ? "77.5vh" : "72vh";
  

  const navigate = useNavigate();

  useEffect(() => {
    if (!authtoken) {
      window.location.href = "/";
    }
  }, [authtoken]);

  const userPermission = checkUserPermissionFunc("configuration", "Week off", "SubMenu");
  
  const queryString =
    "?page_no=" + pageNo +
    "&page_size=" + pageSize +
    "&code=" + (filterDatas.weekOff_code ? filterDatas.weekOff_code : "") +
    "&weekoff_name=" + (filterDatas.weekOff_name ? filterDatas.weekOff_name : "") +
    "&is_active=" + (filterDatas.weekOff_is_active !== undefined ? filterDatas.weekOff_is_active : "") +
    "&search=" + searchText + (sorting ? `&${sorting}` : "");

  // const [data, pageInfo, loading, _message, refetch] = useApiData(getEmployeeWeekOffPagination, {
  //   pageNo,
  //   pageSize,
  //   queryString,
  //   searchText,
  //   sorting
  // });

  const { fetch, update } = useApiMethods();
  const [data, setData] = useState([]);
  const [pageInfo, setPageInfo] = useState([])
  const [loading, setLoading] = useState(false);
  const [filter, setFilter]=useState({pageNo:'', pageSize:'', query:'', search:'', sorting:''})

  const fetchEmployeeWeekOff = async () => {        
    const res = await fetch(
      NEW_EMPLOYEE_WEEK_OFF, 
      filter,
      setLoading
    );
    if (res?.status) {
      setData(res.data.result);
      setPageInfo({
        pageNo: res.data.page_no,
        pageSize: res.data.page_size,
        totalCount: res.data.total_count,
        noOfPages: res.data.no_of_pages,
      });
    }
  };

  useEffect(() => {
    if (!authtoken) {
      window.location.href = "/";
    }
    fetchEmployeeWeekOff();
  }, [filter, editVisible]);

  // useEffect(() => {
  //   if (_message && _message.isErrorMsg && _message.errorMsgText) {
  //     ToastMsg('error', _message.errorMsgText);
  //   }
  // }, [_message, _message.errorMsgText]);

  const addClick = () => {
    setEditVisible(false);
    setDataToBeUpdated({});
    navigate('/configuration/weekoff/add', { state: { fromEdit: false, editDetails: {}, isActive: userPermission?.active !== undefined ? userPermission?.active : true } });
  };

  const handleEditClick = (weekOff) => {
    setDataToBeUpdated(weekOff);
    if (editVisible && Object.keys(dataToBeUpdated).length > 0) {
      ToastMsg("warning", "Please cancel the existing edit operation!")
    }
    else if (!editVisible) {
      setEditVisible(true);
      navigate('/configuration/weekoff/add', { state: { fromEdit: true, editDetails: weekOff, isActive: userPermission?.active !== undefined ? userPermission?.active : true } });
      setDataToBeUpdated(weekOff);
    }
  };

  const handleSearch = () => {
    setEditVisible(false)
    setDataToBeUpdated({});
    setPageNo(1);
    setFilter(1,
      pageSize,
      queryString,
      searchText,
      sorting);
    setDataUpdated(!dataUpdated);
  }

  const handleTableChange = (pagination, filters, sorter) => {
    const sortorder = `sort=${sorter.order === "descend" ? "desc" : sorter.order === "ascend" ? "asc" : ""}&`
    const sortQuery = sorter.order ? `${sortorder}column=${sorter.field}` : ""
    queryRef.current = isDraft ? `is_draft=True` : "" + queryString;
    setFilter((prevFilter) => ({
      ...prevFilter, 
      pageNo: pagination.current, 
      pageSize: pagination.pageSize || prevFilter.pageSize, 
      query: queryRef.current, 
      sorting: sortQuery,
    }));
    setSorting(sortQuery)
  }

  // filter start
  const renderFilter = (data) => {
    setFilterDatas((prevdata) => ({ ...prevdata, ...data }));
    setPageNo(1);
    setFilter((prevFilter) => ({
      ...prevFilter, 
      pageNo: 1, 
      pageSize: pageSize || prevFilter.pageSize, 
      query: `code=${data.weekOff_code ? data.weekOff_code : ""}&weekoff_name=${data.weekOff_name ? data.weekOff_name : ""}&is_active=${data.weekOff_is_active !== undefined ? data.weekOff_is_active : ""}`,
      search: searchText,
      sorting: sorting,
    }));
    setFilterVisible(false);
  }

  const ClosePopUp = () => {
    setFilterVisible(false);
  }

  const clearFilter = () => {
    setFilterDatas(initialData);
    setPageNo(1);
    setFilter(1,
      pageSize,
      queryString,
      searchText,
      sorting);
  }
  //filter end

  const columns = [
    {
      title: "Week-Off Code",
      dataIndex: "code",
      key: "code",
      sorter: true,
      width: "14.28%",
      fixed: "left",
      render: (_, record) => {
        let colors = record?.is_active ? "black" : "#CACACA";
        return (record.code?.length > 8 ?
          <Tooltip title={record.code}>{<span style={{ color: colors }}>{record.code?.slice(0, 20) + "..."}</span>}</Tooltip>
          : <p style={{ color: colors }}>{record.code ? record.code : "-"}</p>)
      }
    },
    {
      title: "Week-Off Name",
      dataIndex: "weekoff_name",
      key: "weekoff_name",
      sorter: true,
      width: "17.96%",
      fixed: "left",
      render: (_, record) => {
        let colors = record?.is_active ? "black" : "#CACACA";
        return (record.weekoff_name?.length > 20 ?
          <Tooltip title={record.weekoff_name}>{<span style={{ color: colors }}>{record.weekoff_name?.slice(0, 20) + "..."}</span>}</Tooltip>
          : <p style={{ color: colors }}>{record.weekoff_name ? record.weekoff_name : "-"}</p>)
      }
    },
    {
      title: "Department",
      dataIndex: "department_name",
      key: "department_name",
      sorter: true,
      width: "15.28%",
      fixed: "left",
      render: (_, record) => {
        let colors = record?.is_active ? "black" : "#CACACA";
        return (record.department_name?.length > 20 ?
          <Tooltip title={record.department_name}>{<span style={{ color: colors }}>{record.department_name?.slice(0, 20) + "..."}</span>}</Tooltip>
          : <p style={{ color: colors }}>{record.department_name ? record.department_name : "-"}</p>)
      }
    },
    {
      title: "Week-Off Rules",
      dataIndex: "weekoff_rules",
      key: "weekoff_rules",
      sorter: true,
      width: "15.28%",
      fixed: "left",
      render: (_, record) => {
        let colors = record?.is_active ? "black" : "#CACACA";
        return (record.weekoff_rules?.length > 20 ?
          <Tooltip title={record.weekoff_rules}>{<span style={{ color: colors }}>{record.weekoff_rules?.slice(0, 20) + "..."}</span>}</Tooltip>
          : <p style={{ color: colors }}>{record.weekoff_rules ? record.weekoff_rules : "-"}</p>)
      }
    },
    {
      title: "Notes",
      dataIndex: "notes",
      key: "notes",
      sorter: true,
      width: "14.88%",
      fixed: "left",
      render: (_, record) =>
      (record?.notes?.length > 28 ?
        <Tooltip title={record?.notes}>{<span style={{ color: record?.is_active ? "black" : "#CACACA" }}>{record?.notes?.slice(0, 25) + "..."}</span>}</Tooltip>
        : <p style={{ color: record?.is_active ? "black" : "#CACACA" }}>{record?.notes ? record?.notes : "-"}</p>)
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      sorter: true,
      width: "12.28%",
      render: (_, record) =>
        record.is_active === true ? (
          <span style={{ color: "black" }}>Active</span>
        ) : (
          <span style={{ color: "#CACACA" }}>Inactive</span>
        ),
      align: 'center',
      fixed: "left",
    },
  ];

  if (userPermission?.edit) {
    columns.push({
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "9%",
      align: 'center',
      fixed: "left",
      render: (_, record) => (
        <div className="flex justify-center items-center">
          <Space size={"middle"}>
            <IconButton
              title="Edit"
              icon={<img src={ImagePaths.edit.default} alt="Edit" />}
              onClick={() => (loading ? "" : handleEditClick(record))}
              testID={'ug_btn_edit'}
            />
            {record.is_draft === true ?
              <IconButton
                title="Delete"
                icon={<img src={ImagePaths.delete.default} alt="Delete" />}
                onClick={() => (loading ? "" : handleDeleteClicked(record?.weekoff_id))}
                testID={'ug_btn_delete'}
              /> : null}
          </Space>
        </div>
      ),
    })
  }

  //draft delete start
  const handleDeleteClicked = (id) => {
    setDeleteClicked((prevdata) => ({
      ...prevdata,
      id: id,
      isDeleteClicked: true
    }));
  }

  const handleCancelBtn = () => {
    setDeleteClicked((prevdata) => ({
      ...prevdata,
      id: undefined,
      isDeleteClicked: false
    }));
  }

  const handleDeleteBtn = async (id) => {
    try {
      // Create FormData object
      const formData = new FormData();
      formData.append("id", id);
      formData.append("is_active", false);
  
      if (isDraft) {
        formData.append("draft_delete", true);
        formData.append("is_draft", true);
      }
  
      // Make the API call
      const response = await update(NEW_EMPLOYEE_WEEK_OFF, formData);
  
      if (response?.status) {
        ToastMsg("success", "Employee Weekoff deleted successfully.");
        handleDraft();
      } else {
        ToastMsg("error", response.message || "Failed to delete the employee weekoff.");
      }
    }
    catch (error) {
      ToastMsg("error", error.message);
    } finally {
      handleCancelBtn();
    }
  }//draft delete end

  const handleFilter = () => {
    setFilterVisible(true)
  }

  const handleDraft = () => {
    setIsDraft(true);
    setFilterVisible(false);
    setSorting("");
    setPageNo(1);
    queryRef.current = `is_draft=True`
    setFilter((prevFilter) => ({
      ...prevFilter, 
      pageNo: 1, 
      query: queryRef.current, 
      sorting: "",
    }));
  }

  const handleBackToHome = () => {
    setIsDraft(false);
    setSorting("");
    setPageNo(1);
    queryRef.current = "";
    setFilter(1,
      pageSize,
      queryRef.current,
      queryString,
      searchText,
      "");
  }

  const handleStateChanges = (search = "", reorderedList = []) => {
    setSearchText(search)
    setReorderedColumns(reorderedList)
  }

  const printData =
    "?page_no=" + pageNo +
    "&page_size=" + pageSize +
    "&code=" + (filterDatas.weekOff_code ? filterDatas.weekOff_code : "") +
    "&weekoff_name=" + (filterDatas.weekOff_name ? filterDatas.weekOff_name : "") +
    "&is_active=" + (filterDatas.weekOff_is_active !== undefined ? filterDatas.weekOff_is_active : "") +
    "&search=" + searchText + (sorting ? `&${sorting}` : "");

  const styles = {
    fltContainer: {
      border: "1px solid #cbcbcb",
      height: tableContainerHeight,
    },
  }

  return (
    <Card className="h-full overflow-hidden">
      <div className={"h-1/6"} >
        <CommonTblHeader pageName={"Weekoff"}
          pageInfo={pageInfo}
          handleSearch={handleSearch} selectedDetails={dataToBeUpdated} addClick={addClick}
          onStateChange={handleStateChanges} handleFilter={handleFilter} columns={columns}
          handleDraft={handleDraft} isDraft={isDraft} handleBackToHome={handleBackToHome}
          url={NEW_EMPLOYEE_WEEK_OFF} query={printData}
          isAddRequired = {userPermission?.add ? true : false}
          isDraftRequired = {userPermission?.draft ? true : false}
          testID={'woff'}
        />
      </div>
      <div className="h-5/6 flex justify-center items-center  mt-1">
        {filterVisible ?
          <div className="w-1/4 mt-5" style={styles.fltContainer}>
            <ConfigurationFilter
              pageName={"Weekoff"}
              filterDatas={filterDatas}
              closeFilter={ClosePopUp}
              filteredData={renderFilter}
              clearData={clearFilter} />
          </div>
          : null}
        <div className={filterVisible ? "mt-5 w-3/4" : "mt-5 w-full"} style={styles.fltContainer}>
        <Table
          columns={reorderedColumns?.length > 0 ? reorderedColumns : columns}
          dataSource={data?.length > 0 ? data : null}
          loading={loading}
          style = {{"--table-container-height": tableContainerHeight}}
          scroll={{ y: `calc(${tableContainerHeight} - 140px)` }}
          onChange={handleTableChange}
          pagination={{
            style: { marginRight: 20, padding: 0 },
            defaultPageSize: pageSize,
            showSizeChanger: false,
            showQuickJumper: true,
            total: pageInfo?.totalCount ? pageInfo?.totalCount : 0,
            pageSizeOptions: ["10", "20", "30"],
            pageSize,
            defaultCurrent: pageNo,
          }}
          key={isDraft ? (dataUpdated ? "draftUpdated" : "draftNotUpdated") : (dataUpdated ? "updated" : "not-updated")}
        />
        </div>
      </div>
      {deleteItem.isDeleteClicked ? <CommonDeletePopup handleCancelBtn={handleCancelBtn} handleDeleteBtn={() => handleDeleteBtn(deleteItem.id)} /> : null}
    </Card>
  );
}

export default EmployeeWeekOff;
